const CANJE_OPERATION = {
    key: 'Canje',
    label: 'Gestión de canje',
};

const VENTILADOR_DE_TECHO_OPERATIONS = [
    { key: 'visitaDiagnosticoRetiroUnidadVTR', label: 'Visita a domicilio + diagnóstico + eventual retiro de la unidad' },
    { key: 'reparacionDomicilioVTR', label: 'Reparación en domicilio y verificación funcional' },
    { key: 'reparacionSencillaTallerVTR', label: 'Reparación en taller y verificación funcional (Sencilla)' },
    { key: 'reparacionComplejaTallerVTR', label: 'Reparación en taller y verificación funcional (Compleja)' },
    { key: 'reinstalaciónDomicilioVTR', label: 'Reinstalación en domicilio y verificación funcional' },
];

export const repairDetailsByType = {
    VentiladorDeTecho: {
        operations: VENTILADOR_DE_TECHO_OPERATIONS,
    },
    TermotanqueElectrico: {
        operations: [
            { key: 'visitaDiagnosticoRetiroUnidadTermot', label: 'Visita a domicilio + diagnóstico + eventual retiro de la unidad' },
            { key: 'reparacionDomicilioTermot', label: 'Reparación en domicilio y verificación funcional' },
            { key: 'reparacionSencillaTallerTermot', label: 'Reparación en taller y verificación funcional' },
            { key: 'reinstalaciónDomicilioTermot', label: 'Reinstalación en domicilio y verificación funcional' },
        ],
    },
    Heladera: {
        operations: [
            { key: 'visitaDiagnosticoHeladera', label: 'Visita a domicilio + diagnóstico' },
            { key: 'reparacionDomicilioHeladera', label: 'Reparacion en domicilio y verificación funcional' },
            { key: 'vacioCargaGasHeladera', label: 'Vacío y carga de gas, con verificación funcional' },
            { key: 'reparacionTallerHeladera', label: 'Reparación en taller y verificación funcional' },
        ],
    },
    Freezer: {
        operations: [
            { key: 'visitaDiagnosticoFREEZER', label: 'Visita a domicilio + diagnóstico' },
            { key: 'reparacionDomicilioFREEZER', label: 'Reparacion en domicilio y verificación funcional' },
            { key: 'vacioCargaGasFREEZER', label: 'Vacío y carga de gas, con verificación funcional' },
            { key: 'reparacionTallerFREEZER', label: 'Reparación en taller y verificación funcional' },
        ],
    },
    Lavasecarropas: { operations: VENTILADOR_DE_TECHO_OPERATIONS },
    Secarropas: { operations: VENTILADOR_DE_TECHO_OPERATIONS },
};

export const getRepairDetails = (type) => repairDetailsByType[type];

export const requiresRepairDetails = (type) => Boolean(getRepairDetails(type));
